import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.logisticEdit || initialState;

export const selectCountries = createSelector(
  [selectDomain],
  (state) => state.countries
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectCities = createSelector(
  [selectDomain],
  (state) => state.cities
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectLogisticDetails = createSelector([selectDomain], (state) => {
  const logisticDetails = state.logisticDetails;
  if (logisticDetails) {
    return {
      ...logisticDetails,
      address: {
        ...logisticDetails.address,
        state: logisticDetails?.address?.state?._id,
        country: logisticDetails?.address?.country?._id,
        city: logisticDetails?.address?.city?._id,
      },
      operatingStates: logisticDetails.operatingStates.map(
        (state) => state._id
      ),
    };
  }
});
